<template>
  <div>
    <el-drawer
      title="模板列表"
      :visible.sync="templateListConfig.is_show"
      append-to-body
      :close-on-press-escape="false"
      :wrapper-closable="false"
    >
      <div class="p-20">
        <app-filter
          :filter-list="table_filter"
          @search="search"
        />
        <app-table
          ref="my-table"
          v-loading="templateListConfig.is_loading"
          :table-key="table_key"
          :tablep="table_params"
          :page-size="15"
          :get-data="getTemplateListApi"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import TemplateResource from '@/api/template';
const templateResource = new TemplateResource();

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  props: {
    /** 模板列表配置 */
    templateListConfig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      /** 模板类型表 */
      template_type_map: {
        project: 'project',
        basic_set_form: 'project_base_param',
        target_form: 'project_delivery_content',
        optimize_form: 'project_optimize_goal',
        delivery_range_form: 'project_delivery_range',
        audience_form: 'project_audience',
        delivery_setting_form: 'project_delivery_setting',
        channel_form: 'channel',
        promotion: 'promotion',
        native_form: 'promotion_identity',
        material_form: 'promotion_materials',
        product_info_form: 'promotion_product_info',
        budget_and_bid_form: 'promotion_budget_and_bid',
        additional_creative_info_form: 'promotion_source',
        anchor_material_list_form: 'promotion_native_anchor',
        ad: 'ad',
      },
      table_filter: require('../module/table-filter.js')(this),
      table_key: require('../module/table-key.js')(this),
      table_params: {
        advertiser: 'jrtt',
        page: 1,
        limit: 15,
      },
    };
  },
  methods: {
    /** 搜索模板 */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs['my-table'].seekTable();
    },
    /** 获取模板列表 */
    getTemplateListApi(data) {
      return new Promise((resolve, reject) => {
        templateResource.getTemplateListApi({
          ...data,
          type: this.template_type_map[this.templateListConfig.type],
        }).then(res => {
          res.list = res.list.map(e => {
            return {
              id: e.id,
              name: e.name,
              template_data: `${e.name} - ${e.template_data}`,
            };
          });
          resolve(res);
        });
      });
    },
    /** 删除模板 */
    deleteTemplate(id) {
      templateResource.deleteTemplateApi(id).then(response => {
        this.$message.success(response.message);
        this.$refs['my-table'].refer();
      });
    },
    /** 应用模板 */
    confirm(data){
      this.$emit('confirm', data);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer__header span{
  font-size: 18px;
  font-weight: 600;
}
</style>
